import type { IInputBalloon, ITheme } from '@/interface';
import React from 'react';
import handleUbbTextWithV2 from '@/utils/shared/handleUbbTextWithV2';
import InputBalloonWithTheme from '../InputBalloonWithTheme/render';
import classNames from 'classnames';
import styles from './index.module.less';

type TAlign = 'left'|'center'|'right';
interface IProps{
    className?: string;
    style?: React.CSSProperties;
    title?: string;
    /**
     * 单独设置标题的对齐方向
     * @default 'center'
     */
    titleAlign?: TAlign;
    titleClassName?: string;
    titleStyle?: React.CSSProperties;
    desc?: IInputBalloon|string;
    /**
     * 单独设置描述的对齐方向
     * @default 'center'
     */
    descAlign?: TAlign;
    descClassName?: string;
    descStyle?: React.CSSProperties;
    /**
     * 当传入的desc 为 InputBalloon 时 生效
     */
    balloonClassName?: string;
    /**
     * 文案的对齐方向
     * @default 'center'
     */
    align?: TAlign;
    /**
     * @default 'light'
     */
    theme?: ITheme;

    titleType?: 'h1' | 'h2'
}

/**
 * 通用标题和描述
 * @param props
 * @returns
 */
const CompBasicTitleWithDesc: React.FC<IProps> = (props) => {

    const theme = props.theme ?? 'light';

    const desc = React.useMemo(() => {
        if (!props.desc) {
            return null;
        }

        if (typeof props.desc === 'string') {

            return (
                <div
                    className={ classNames(styles['desc'], props.descClassName) }
                    style={{
                        textAlign: props.descAlign,
                        ...props.descStyle
                    }}
                    dangerouslySetInnerHTML={{
                        __html: handleUbbTextWithV2(props.desc, { mode: 'normal' })
                    }}
                />
            );
        }

        return (
            <InputBalloonWithTheme
                theme={ props.theme ?? 'light' }
                data={ props.desc }
                className={ classNames(styles['desc'], props.descClassName) }
                balloonClassName={ props.balloonClassName }
                align={ props.descAlign }
                style={ props.descStyle }
            />
        );

    }, [props.balloonClassName, props.desc, props.descAlign,
        props.descClassName, props.descStyle, props.theme]);

    if (!props.title && !props.desc) {
        return null;
    }

    return (
        <div
            className={ classNames(styles['title-with-desc-content'], styles[__MERCHANT__], styles[theme], props.className) }
            style={{
                textAlign: props.align,
                ...props.style
            }}
        >
            {
                props.title ? (
                    props.titleType === 'h1' ?(
                        <h1
                        className={ classNames(styles['title'], props.titleClassName) }
                        dangerouslySetInnerHTML={{
                            __html: handleUbbTextWithV2(props.title, { mode: 'inline' })
                        }}
                        style={{
                            textAlign: props.titleAlign,
                            ...props.titleStyle
                        }}
                    >
                    </h1>
                    ):
                    <h2
                        className={ classNames(styles['title'], props.titleClassName) }
                        dangerouslySetInnerHTML={{
                            __html: handleUbbTextWithV2(props.title, { mode: 'inline' })
                        }}
                        style={{
                            textAlign: props.titleAlign,
                            ...props.titleStyle
                        }}
                    >
                    </h2>
                ) : null
            }
            {
                desc
            }
        </div>
    );
};

export default CompBasicTitleWithDesc;
